<template>

  <div>
    <!-- Title -->
    <template v-if="isSap">
      <editMedicDoseUpper :isDashbTitle="true"/>
    </template>
    <template v-else>
      <div class="row tooltip">
        <text-item :txt="exprTerm" styles="font-xl" class="title-max-w"/>
        <span class="tooltiptext max-w-500 mtop-50 font-s">{{exprTerm}}</span>
      </div>
    </template>

    <!-- ActionMenu -->
    <div class="row gap-04">
      <itemModal v-if="currentEntryStore.showAnnotations" :center="true" uiId="dashBoardShowAnnotations">
        <buttonGroup styles="size-l border-none rnd-l"  class="mleft-02">
          <svg-item icon="lightning" styles="size-m main-m"/>
        </buttonGroup>
        <template #modal>
          <showAnnotations :content="uiStore.dashBoardItem"/>
        </template>
      </itemModal>

    </div>
  </div>

  <!-- Body -->
  <div class="overflow-y">
    <div style="min-height: 100%;" class="dashb-body">

      <div class="row">
        <div style="flex: 0 1 40%"/>
        <div style="flex: 1 0 30rem;">

          <!-- Chart -->
          <div ref="chartRef" class="mtop-20" style="height: 20rem;" :style="{ display: showChart ? 'block' : 'none' }"/>

          <!-- Ccl -->
          <div class="mtop-40 row w-full">
            <dashbExprCcl class="mleft-30"/>
          </div>

        </div>
      </div>

      <!-- Timelines -->
      <div class="mtop-50">
        <dashbExprBilan/>
      </div>

    </div>
  </div>

</template>



<script setup>
import showAnnotations from '../showAnnotations.vue'
import dashbExprCcl from './dashbExprCcl.vue'
import dashbExprBilan from './dashbExprBilan.vue'
import editMedicDoseUpper from "../editMedic/editMedicDoseUpper.vue"

import * as echarts from 'echarts'
import { ref, computed, watch, onMounted } from 'vue'
import { useUiStore } from '@/stores/ui'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { createChartDataForAssessed, createOption } from '@/functions/charts'

const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()

const currExpr = computed(() => {
  if (!currentEntryStore.hasCurrentEntry) return "";
  const dashboardExpr = uiStore.dashBoardItem;
  return dashboardExpr.expression ? dashboardExpr.expression : dashboardExpr;
})

const exprTerm = computed(() => {
  return currExpr.value?.originalText || "";
})

const isSap = (currExpr.value?.expressionType === "SubstanceAdministrationPrescription")

const chartContent = ref(null)
const showChart = ref(true)
const chartRef = ref(null)

function initChart() {
  chartContent.value = echarts.init(chartRef.value, null, { renderer: 'svg'})    //alternative: canvas
}

function updateChart() {
  const allExpressions = currentEntryStore.allExpressions
  const assessmentExpr = uiStore.dashBoardItem 
  const chartData = createChartDataForAssessed(allExpressions, assessmentExpr)
  if (chartData.length) {
    showChart.value = true
    chartContent.value.setOption(createOption(chartData))
  } else {
    showChart.value = false
  }
}

watch(
  () => [
    uiStore.dashBoardItem,
    currentEntryStore.currentEntryId
  ],
  async () => {
    updateChart();
  },
)

onMounted(async () => {
  initChart();
  updateChart(); //is also loaded by dashbExprBilan
})

</script>


<style scoped>
.title-max-w {
  max-width: 1200px;
}
.overflow-y {
  height: calc(100vh - 170px);
  overflow-y: auto;
}
</style>